import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Button,
  TextArea,
  Input
} from 'semantic-ui-react'

const CardPayingMeBillingUX = (props: any) => {
    return(
      <div
        id="CardPayingMeBillingUX-div-0"
        style={{ padding: "10px" }}>
        <div
          id="CardPayingMeBillingUX-div-1"
          style={{ display: "flex", margin: "10px 20px", alignItems: "baseline", borderBottom: "2px solid var(--primary-theme-color)", paddingBottom: "10px" }}>

          <label
            id="CardPayingMeBillingUX-label-3"
            style={{ fontWeight: "bold", fontSize: "24px", color: "var(--primary-theme-color)" }}>
            การรับชำระเงิน
          </label>
          <div
            id="CardPayingMeBillingUX-div-139"
            style={{ margin: "0px 50px" }}>
            {props.patientNameAndHN}
          </div>
          <div
            id="CardPayingMeBillingUX-div-6"
            style={{ flex: 1 }}>

          </div>
          <label
            id="CardPayingMeBillingUX-label-5">
            {props.receiptCode}
          </label>
        </div>
        <div
          className="--override-disabled --grey"
          id="CardPayingMeBillingUX-div-2"
          style={{ margin: "20px" }}>

          <Form
            id="CardPayingMeBillingUX-Form-7">
            <FormGroup
              id="CardPayingMeBillingUX-FormGroup-135">
              <FormField
                id="CardPayingMeBillingUX-FormField-136"
                style={{ padding: "0px 30px" }}
                width="6">
              </FormField>
              <FormField
                id="CardPayingMeBillingUX-FormField-137"
                style={{ padding: "0px 40px" }}>
                <label
                  id="CardPayingMeBillingUX-label-153">
                  รูปแบบการชำระ
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardPayingMeBillingUX-FormGroup-174">
              <FormField
                id="CardPayingMeBillingUX-FormField-175"
                width="6">
                <FormGroup
                  id="CardPayingMeBillingUX-FormGroup-8"
                  style={{ margin: "0px",  }}>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-9"
                    style={{ display: "flex", alignItems: "center", padding : "20px 0px 20px", }}
                    width="7">
                    <div
                      id="CardPayingMeBillingUX-div-147">
                      ค่าใช้จ่ายทั้งหมด
                    </div>
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-10"
                    style={{ display: "flex", alignItems: "center", padding : "20px 20px 20px 10px", }}
                    width="9">
                    <div
                      className="ui label large fluid"
                      id="CardPayingMeBillingUX-div-19"
                      style={{ textAlign: "right" }}>
                      {( props.sumAmount.price || "0.00" )}
                    </div>
                  </FormField>
                </FormGroup>
                <FormGroup
                  id="CardPayingMeBillingUX-FormGroup-26"
                  style={{ margin: "0px",  }}>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-67"
                    style={{ display: "flex", alignItems: "center", padding : "0px 0px 20px 0px", }}
                    width="7">
                    <div
                      id="CardPayingMeBillingUX-div-149"
                      style={{ color: "var(--primary-theme-color)"  }}>
                      ส่วนลดรวม (ท้ายใบเสร็จ)
                    </div>
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-68"
                    style={{ display: "flex", alignItems: "center", padding : "0px 20px 20px 10px", }}
                    width="9">
                    <div
                      id="CardPayingMeBillingUX-div-109"
                      style={{ width: "100%" }}>
                      {props.inputDiscountCode}
                    </div>
                  </FormField>
                </FormGroup>
                <FormGroup
                  id="CardPayingMeBillingUX-FormGroup-27"
                  style={{ margin: "0px",  }}>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-60"
                    style={{ display: "flex", alignItems: "center", padding : "0px 0px 5px 0px", }}
                    width="7">
                    <div
                      id="CardPayingMeBillingUX-div-324"
                      style={{ color: "var(--primary-theme-color)"  }}>
                      คูปองส่วนลด (Voucher)
                    </div>
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-61"
                    style={{ display: "flex", alignItems: "center", padding : "0px 20px 5px 10px", }}
                    width="9">
                    <div
                      id="CardPayingMeBillingUX-div-323"
                      style={{ width: "100%" }}>
                      {props.voucherInput}
                    </div>
                  </FormField>
                </FormGroup>
                <FormGroup
                  id="CardPayingMeBillingUX-FormGroup-27"
                  style={{ margin: "0px",  }}>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-60"
                    style={{ display: "flex", alignItems: "center", padding : "0px 0px 20px 0px", }}
                    width="7">
                    <div
                      id="CardPayingMeBillingUX-div-324">
                      {props.selectVoucherHeader}
                    </div>
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-61"
                    style={{ display: "flex", alignItems: "center", padding : "0px 20px 20px 10px", }}
                    width="9">
                    <div
                      id="CardPayingMeBillingUX-div-323"
                      style={{ width: "100%" }}>
                      {props.selectVoucherData}
                    </div>
                  </FormField>
                </FormGroup>
                <FormGroup
                  id="CardPayingMeBillingUX-FormGroup-27"
                  style={{ margin: "0px",  }}>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-60"
                    style={{ display: "flex", alignItems: "center", padding : "0px 0px 20px 0px", }}
                    width="7">
                    <div
                      id="CardPayingMeBillingUX-div-151">
                      ต้องชำระ
                    </div>
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-61"
                    style={{ display: "flex", alignItems: "center", padding : "0px 20px 20px 10px", }}
                    width="9">
                    <div
                      className="ui label large fluid"
                      id="CardPayingMeBillingUX-div-106"
                      style={{ textAlign: "right", background: "rgba(255, 230, 230, 1)" }}>
                      {(props.sumAmount.payable || "0.00")}
                    </div>
                  </FormField>
                </FormGroup>
                <FormGroup
                  id="CardPayingMeBillingUX-FormGroup-28"
                  style={{ margin: "0px",  }}>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-53"
                    style={{ display: "flex", alignItems: "center", padding : "0px 0px 20px 0px", }}
                    width="7">
                    <div
                      id="CardPayingMeBillingUX-div-152">
                      ยอดคงเหลือต้องชำระ
                    </div>
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-54"
                    style={{ display: "flex", alignItems: "center", padding : "0px 20px 20px 10px", }}
                    width="9">
                    <div
                      className={`ui label large fluid ${Number(props.rawOweText) > Number(props.rawTotalText) ? "red" : "green"}`}
                      id="CardPayingMeBillingUX-div-103"
                      style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
                      {props.oweText}
                    </div>
                  </FormField>
                </FormGroup>
                <FormGroup
                  id="CardPayingMeBillingUX-FormGroup-28"
                  style={{ margin: "0px",  }}>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-53"
                    style={{ padding : "0px 0px 20px 0px", }}
                    width="16">
                    <div
                      id="CardPayingMeBillingUX-div-152"
                      style={{ margin: "10px 0px" }}>
                      หมายเหตุ
                    </div>
                    <TextArea
                      id="CardPayingMeBillingUX-TextArea-318"
                      onChange={props.onChangeRemark}
                      style={{ resize: "none" }}
                      value={props.remarkText}>
                    </TextArea>
                  </FormField>
                </FormGroup>
              </FormField>
              <FormField
                id="CardPayingMeBillingUX-FormField-176"
                width="10">
                <FormGroup
                  id="CardPayingMeBillingUX-FormGroup-8"
                  style={{ margin: "0px",  }}>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-11"
                    style={{ display: "flex", alignItems: "center", padding : "20px 0px 20px 30px", borderTop: "1px dashed var(--primary-theme-color)", borderLeft: "1px dashed var(--primary-theme-color)" }}
                    width="4">
                    <div
                      id="CardPayingMeBillingUX-div-140">
                      เงินสด
                    </div>
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-12"
                    style={{ display: "flex", alignItems: "center", padding : "20px 0px 20px 0px", borderTop: "1px dashed var(--primary-theme-color)", }}
                    width="4">
                    <div
                      id="CardPayingMeBillingUX-div-20"
                      style={{ width: "100%" }}>
                      {props.inputCashAmountText}
                    </div>
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-13"
                    style={{ display: "flex", alignItems: "center", padding : "20px 10px 20px 10px", borderTop: "1px dashed var(--primary-theme-color)", }}
                    width="1">
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-14"
                    style={{ display: "flex", alignItems: "center", padding : "20px 0px 20px 30px", borderTop: "1px dashed var(--primary-theme-color)", }}
                    width="3">
                    <div
                      id="CardPayingMeBillingUX-div-148">
                      เงินทอน
                    </div>
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-15"
                    style={{ display: "flex", alignItems: "center", padding : "20px 30px 20px 0px", borderTop: "1px dashed var(--primary-theme-color)", borderRight: "1px dashed var(--primary-theme-color)", }}
                    width="4">
                    <div
                      className="ui label large fluid"
                      id="CardPayingMeBillingUX-div-21"
                      style={{ textAlign: "right" }}>
                      {( props.changeText  || "0.00" )}
                    </div>
                  </FormField>
                </FormGroup>
                <FormGroup
                  id="CardPayingMeBillingUX-FormGroup-26"
                  style={{ margin: "0px",  }}>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-69"
                    style={{ display: "flex", alignItems: "center", padding : "0px 0px 20px 30px", borderLeft: "1px dashed var(--primary-theme-color)" }}
                    width="4">
                    <div
                      id="CardPayingMeBillingUX-div-141">
                      เงินโอน/QR Code
                    </div>
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-70"
                    style={{ display: "flex", alignItems: "center", padding : "0px 0px 20px 0px", }}
                    width="4">
                    <div
                      className="ui label large fluid"
                      id="CardPayingMeBillingUX-div-108"
                      style={{ textAlign: "right" }}>
                      {( props.transferText || "0.00" )}
                    </div>
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-71"
                    style={{ display: "flex", alignItems: "center", padding : "0px 10px 20px 10px",  }}
                    width="1">
                    <Button
                      circular={true}
                      icon="plus"
                      id="CardPayingMeBillingUX-Button-133"
                      onClick={()=> props.onAddPaymentMethod(2)}
                      size="mini"
                      style={{ background: "var(--primary-theme-color)", color: "white" }}
                      type="button">
                    </Button>
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-72"
                    style={{ display: "flex", alignItems: "center", padding : "0px 0px 20px 30px", }}
                    width="3">
                    <div
                      id="CardPayingMeBillingUX-div-150">
                      ลดเศษสตางค์
                    </div>
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-73"
                    style={{ display: "flex", alignItems: "center", padding : "0px 30px 20px 0px", borderRight: "1px dashed var(--primary-theme-color)", }}
                    width="4">
                    <div
                      className="ui label large fluid"
                      id="CardPayingMeBillingUX-div-107"
                      style={{ textAlign: "right" }}>
                      {( props.roundOffText || "\u00a0" )}
                    </div>
                  </FormField>
                </FormGroup>
                <FormGroup
                  id="CardPayingMeBillingUX-FormGroup-27"
                  style={{ margin: "0px",  }}>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-62"
                    style={{ display: "flex", alignItems: "center", padding : "0px 0px 20px 30px", borderLeft: "1px dashed var(--primary-theme-color)" }}
                    width="4">
                    <div
                      id="CardPayingMeBillingUX-div-142">
                      บัตรเครดิต
                    </div>
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-63"
                    style={{ display: "flex", alignItems: "center", padding : "0px 0px 20px 0px", }}
                    width="4">
                    <div
                      className="ui label large fluid"
                      id="CardPayingMeBillingUX-div-105"
                      style={{ textAlign: "right" }}>
                      {( props.cardText || "0.00" )}
                    </div>
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-64"
                    style={{ display: "flex", alignItems: "center", padding : "0px 10px 20px 10px",  }}
                    width="1">
                    <Button
                      circular={true}
                      icon="plus"
                      id="CardPayingMeBillingUX-Button-132"
                      onClick={()=> props.onAddPaymentMethod(3)}
                      size="mini"
                      style={{ background: "var(--primary-theme-color)", color: "white" }}
                      type="button">
                    </Button>
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-65"
                    style={{ display: "flex", alignItems: "center", padding : "0px 0px 20px 30px", }}
                    width="3">
                    <label
                      id="CardPayingMeBillingUX-label-79">

                    </label>
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-66"
                    style={{ display: "flex", alignItems: "center", padding : "0px 30px 20px 0px", borderRight: "1px dashed var(--primary-theme-color)", }}
                    width="4">
                    <div
                      id="CardPayingMeBillingUX-div-104"
                      style={{ width: "100%" }}>

                    </div>
                  </FormField>
                </FormGroup>
                <FormGroup
                  id="CardPayingMeBillingUX-FormGroup-28"
                  style={{ margin: "0px",  }}>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-55"
                    style={{ display: "flex", alignItems: "center", padding : "0px 0px 20px 30px", borderLeft: "1px dashed var(--primary-theme-color)" }}
                    width="4">
                    <div
                      id="CardPayingMeBillingUX-div-143">
                      บัตรเดบิต
                    </div>
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-56"
                    style={{ display: "flex", alignItems: "center", padding : "0px 0px 20px 0px", }}
                    width="4">
                    <div
                      className="ui label large fluid"
                      id="CardPayingMeBillingUX-div-102"
                      style={{ textAlign: "right" }}>
                      {( props.cardDebitText || "0.00" )}
                    </div>
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-57"
                    style={{ display: "flex", alignItems: "center", padding : "0px 10px 20px 10px",  }}
                    width="1">
                    <Button
                      circular={true}
                      icon="plus"
                      id="CardPayingMeBillingUX-Button-131"
                      onClick={()=> props.onAddPaymentMethod(9)}
                      size="mini"
                      style={{ background: "var(--primary-theme-color)", color: "white" }}
                      type="button">
                    </Button>
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-58"
                    style={{ display: "flex", alignItems: "center", padding : "0px 0px 20px 30px", }}
                    width="3">
                    <label
                      id="CardPayingMeBillingUX-label-82">

                    </label>
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-59"
                    style={{ display: "flex", alignItems: "center", padding : "0px 30px 20px 0px", borderRight: "1px dashed var(--primary-theme-color)", }}
                    width="4">
                    <div
                      id="CardPayingMeBillingUX-div-101"
                      style={{ width: "100%" }}>

                    </div>
                  </FormField>
                </FormGroup>
                <FormGroup
                  id="CardPayingMeBillingUX-FormGroup-29"
                  style={{ margin: "0px",  }}>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-48"
                    style={{ display: "flex", alignItems: "center", padding : "0px 0px 20px 30px", borderLeft: "1px dashed var(--primary-theme-color)" }}
                    width="4">
                    <div
                      id="CardPayingMeBillingUX-div-144">
                      แคชเชียร์เช็ค
                    </div>
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-49"
                    style={{ display: "flex", alignItems: "center", padding : "0px 0px 20px 0px", }}
                    width="4">
                    <div
                      className="ui label large fluid"
                      id="CardPayingMeBillingUX-div-99"
                      style={{ textAlign: "right" }}>
                      {( props.chequeText || "0.00")}
                    </div>
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-50"
                    style={{ display: "flex", alignItems: "center", padding : "0px 10px 20px 10px",  }}
                    width="1">
                    <Button
                      circular={true}
                      icon="plus"
                      id="CardPayingMeBillingUX-Button-130"
                      onClick={()=> props.onAddPaymentMethod(4)}
                      size="mini"
                      style={{ background: "var(--primary-theme-color)", color: "white" }}
                      type="button">
                    </Button>
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-51"
                    style={{ display: "flex", alignItems: "center", padding : "0px 0px 20px 30px", }}
                    width="3">
                    <label
                      id="CardPayingMeBillingUX-label-85">

                    </label>
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-52"
                    style={{ display: "flex", alignItems: "center", padding : "0px 30px 20px 0px", borderRight: "1px dashed var(--primary-theme-color)", }}
                    width="4">
                    <div
                      id="CardPayingMeBillingUX-div-98"
                      style={{ width: "100%" }}>

                    </div>
                  </FormField>
                </FormGroup>
                <FormGroup
                  id="CardPayingMeBillingUX-FormGroup-30"
                  style={{ margin: "0px",  }}>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-41"
                    style={{ display: "flex", alignItems: "center", padding : "0px 0px 20px 30px", borderLeft: "1px dashed var(--primary-theme-color)" }}
                    width="4">
                    <div
                      id="CardPayingMeBillingUX-div-145">
                      คูปองเงินสด
                    </div>
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-42"
                    style={{ display: "flex", alignItems: "center", padding : "0px 0px 20px 0px", }}
                    width="4">
                    <div
                      className="ui label large fluid"
                      id="CardPayingMeBillingUX-div-97"
                      style={{ textAlign: "right" }}>
                      {( props.couponText || "0.00" )}
                    </div>
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-43"
                    style={{ display: "flex", alignItems: "center", padding : "0px 10px 20px 10px",  }}
                    width="1">
                    <Button
                      circular={true}
                      icon="plus"
                      id="CardPayingMeBillingUX-Button-129"
                      onClick={()=> props.onAddPaymentMethod(5)}
                      size="mini"
                      style={{ background: "var(--primary-theme-color)", color: "white" }}
                      type="button">
                    </Button>
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-44"
                    style={{ display: "flex", alignItems: "center", padding : "0px 0px 20px 30px", }}
                    width="3">
                    <label
                      id="CardPayingMeBillingUX-label-88">

                    </label>
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-45"
                    style={{ display: "flex", alignItems: "center", padding : "0px 30px 20px 0px", borderRight: "1px dashed var(--primary-theme-color)", }}
                    width="4">
                    <div
                      id="CardPayingMeBillingUX-div-94"
                      style={{ width: "100%" }}>

                    </div>
                  </FormField>
                </FormGroup>
                <FormGroup
                  id="CardPayingMeBillingUX-FormGroup-31"
                  style={{ margin: "0px",  }}>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-34"
                    style={{ display: "flex", alignItems: "center", padding : "0px 0px 20px 30px", borderBottom: "1px dashed var(--primary-theme-color)", borderLeft: "1px dashed var(--primary-theme-color)" }}
                    width="4">
                    <label
                      id="CardPayingMeBillingUX-label-90">
                      รวมยอดชำระทั้งหมด
                    </label>
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-35"
                    style={{ display: "flex", alignItems: "center", padding : "0px 0px 20px 0px", borderBottom: "1px dashed var(--primary-theme-color)",  }}
                    width="4">
                    <div
                      className="ui label large fluid"
                      id="CardPayingMeBillingUX-div-96"
                      style={{ textAlign: "right", background: "rgba(255, 230, 230, 1)" }}>
                      {( props.totalText || "0.00" )}
                    </div>
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-36"
                    style={{ display: "flex", alignItems: "center", padding : "0px 10px 20px 10px", borderBottom: "1px dashed var(--primary-theme-color)",  }}
                    width="1">
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-37"
                    style={{ display: "flex", alignItems: "center", padding : "0px 0px 20px 30px",  borderBottom: "1px dashed var(--primary-theme-color)", }}
                    width="3">
                    <label
                      id="CardPayingMeBillingUX-label-91">

                    </label>
                  </FormField>
                  <FormField
                    id="CardPayingMeBillingUX-FormField-38"
                    style={{ display: "flex", alignItems: "center", padding : "0px 30px 20px 0px", borderBottom: "1px dashed var(--primary-theme-color)", borderRight: "1px dashed var(--primary-theme-color)" }}
                    width="4">
                    <div
                      id="CardPayingMeBillingUX-div-92"
                      style={{ width: "100%" }}>

                    </div>
                  </FormField>
                </FormGroup>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardPayingMeBillingUX-FormGroup-170">
              <FormField
                id="CardPayingMeBillingUX-FormField-171">
                <div
                  id="CardPayingMeBillingUX-div-172"
                  style={{ width: "100%", marginTop: "0px" }}>
                  {props.SubRepeaterPayMethod}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardPayingMeBillingUX-FormGroup-154"
              style={{ display: "flex", alignItems: "center", marginTop: "0px" }}>
              <FormField
                id="CardPayingMeBillingUX-FormField-155">
                <div
                  id="CardPayingMeBillingUX-div-161">
                  ชื่อผู้ให้บริการบนใบเสร็จ
                </div>
              </FormField>
              <FormField
                id="CardPayingMeBillingUX-FormField-156"
                width="4">
                <div
                  id="CardPayingMeBillingUX-div-162"
                  style={{ width: "100%" }}>
                  {props.doctorDropDown}
                </div>
              </FormField>
              <FormField
                id="CardPayingMeBillingUX-FormField-157"
                style={{ flex: 1 }}>
              </FormField>
              <FormField
                id="CardPayingMeBillingUX-FormField-158">
                <div
                  id="CardPayingMeBillingUX-div-163">
                  ชื่อผู้รับบริการบนใบเสร็จ
                </div>
              </FormField>
              <FormField
                id="CardPayingMeBillingUX-FormField-159"
                width="4">
                <div
                  id="CardPayingMeBillingUX-div-164"
                  style={{ width: "100%" }}>
                  {props.patientDropDown}
                </div>
              </FormField>
              <FormField
                id="CardPayingMeBillingUX-FormField-160">
                <Button
                  disabled={props.cannotPay}
                  id="CardPayingMeBillingUX-Button-165"
                  onClick={props.onPay}
                  size="mini"
                  style={{ backgroundColor: "var(--primary-theme-color)", color: "white" }}
                  type="button">
                  รับชำระเงิน
                </Button>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardPayingMeBillingUX-FormGroup-330">
              <FormField
                id="CardPayingMeBillingUX-FormField-155">
                <div
                  id="CardPayingMeBillingUX-div-161"
                  style={{ display: "flex", alignItems: "center", marginTop: "0px" }}>
                  Affiliate code
                </div>
              </FormField>
              <FormField
                id="CardPayingMeBillingUX-FormField-155">
                <Input
                  id="CardPayingMeBillingUX-Input-337"
                  onChange={props.onChangeAffiliateCode}
                  onKeyDown={(e) => { if (e.key === "Enter") props.onCheckAffiliate?.(); }}
                  style={{ border: (props.affiliate?.code && !props.affiliate?.name) ? "1px solid red" : undefined }}
                  value={props.affiliate?.code || ""}>
                </Input>
              </FormField>
              <FormField
                id="CardPayingMeBillingUX-FormField-155">
                <Button
                  color="teal"
                  disabled={!props.affiliate?.code?.trim() || props.affiliate?.checking}
                  id="CardPayingMeBillingUX-Button-165"
                  loading={props.affiliate?.checking}
                  onClick={props.onCheckAffiliate}
                  type="button">
                  check
                </Button>
              </FormField>
              <FormField
                id="CardPayingMeBillingUX-FormField-155">
                <label
                  id="CardPayingMeBillingUX-label-340">
                  {props.affiliate?.name || ""}
                </label>
              </FormField>
            </FormGroup>
          </Form>
        </div>
        <div
          id="CardPayingMeBillingUX-div-173">
          {props.Loader}
        </div>
      </div>
    )
}


export default CardPayingMeBillingUX

export const screenPropsDefault = {}

/* Date Time : Mon Oct 19 2026 11:49:35 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"10px\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", margin: \"10px 20px\", alignItems: \"baseline\", borderBottom: \"2px solid var(--primary-theme-color)\", paddingBottom: \"10px\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "--override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"20px\" }"
        }
      },
      "seq": 140,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "label",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "การรับชำระเงิน"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-label-3"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"24px\", color: \"var(--primary-theme-color)\" }"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "label",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.receiptCode"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-label-5"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-6"
        },
        "style": {
          "type": "code",
          "value": "{ flex: 1 }"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "Form",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-Form-7"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 135,
      "name": "FormGroup",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormGroup-135"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 136,
      "name": "FormField",
      "parent": 135,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-136"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"0px 30px\" }"
        },
        "width": {
          "type": "value",
          "value": "6"
        }
      },
      "seq": 136,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 137,
      "name": "FormField",
      "parent": 135,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-137"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"0px 40px\" }"
        },
        "width": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": null,
      "id": 139,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientNameAndHN"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-139"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 50px\" }"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 153,
      "name": "label",
      "parent": 137,
      "props": {
        "children": {
          "type": "value",
          "value": "รูปแบบการชำระ"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-label-153"
        }
      },
      "seq": 153,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 154,
      "name": "FormGroup",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormGroup-154"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", marginTop: \"0px\" }"
        }
      },
      "seq": 174,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 155,
      "name": "FormField",
      "parent": 154,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-155"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 155,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 156,
      "name": "FormField",
      "parent": 154,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-156"
        },
        "width": {
          "type": "value",
          "value": "4"
        }
      },
      "seq": 156,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 157,
      "name": "FormField",
      "parent": 154,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-157"
        },
        "style": {
          "type": "code",
          "value": "{ flex: 1 }"
        }
      },
      "seq": 157,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 158,
      "name": "FormField",
      "parent": 154,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-158"
        }
      },
      "seq": 158,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 159,
      "name": "FormField",
      "parent": 154,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-159"
        },
        "width": {
          "type": "value",
          "value": "4"
        }
      },
      "seq": 159,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 160,
      "name": "FormField",
      "parent": 154,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-160"
        }
      },
      "seq": 160,
      "void": false
    },
    {
      "from": null,
      "id": 161,
      "name": "div",
      "parent": 155,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อผู้ให้บริการบนใบเสร็จ"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-161"
        }
      },
      "seq": 161,
      "void": false
    },
    {
      "from": null,
      "id": 162,
      "name": "div",
      "parent": 156,
      "props": {
        "children": {
          "type": "code",
          "value": "props.doctorDropDown"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-162"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 162,
      "void": false
    },
    {
      "from": null,
      "id": 163,
      "name": "div",
      "parent": 158,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อผู้รับบริการบนใบเสร็จ"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-163"
        }
      },
      "seq": 163,
      "void": false
    },
    {
      "from": null,
      "id": 164,
      "name": "div",
      "parent": 159,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientDropDown"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-164"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 164,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 165,
      "name": "Button",
      "parent": 160,
      "props": {
        "children": {
          "type": "value",
          "value": "รับชำระเงิน"
        },
        "color": {
          "type": "code",
          "value": ""
        },
        "disabled": {
          "type": "code",
          "value": "props.cannotPay"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-Button-165"
        },
        "onClick": {
          "type": "code",
          "value": "props.onPay"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{ backgroundColor: \"var(--primary-theme-color)\", color: \"white\" }"
        },
        "type": {
          "type": "value",
          "value": "button"
        }
      },
      "seq": 165,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 170,
      "name": "FormGroup",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormGroup-170"
        }
      },
      "seq": 170,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 171,
      "name": "FormField",
      "parent": 170,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-171"
        },
        "width": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 171,
      "void": false
    },
    {
      "from": null,
      "id": 172,
      "name": "div",
      "parent": 171,
      "props": {
        "children": {
          "type": "code",
          "value": "props.SubRepeaterPayMethod"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-172"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", marginTop: \"0px\" }"
        }
      },
      "seq": 172,
      "void": false
    },
    {
      "from": null,
      "id": 173,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.Loader"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-173"
        }
      },
      "seq": 173,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 174,
      "name": "FormGroup",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormGroup-174"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 175,
      "name": "FormField",
      "parent": 174,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-175"
        },
        "width": {
          "type": "value",
          "value": "6"
        }
      },
      "seq": 175,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 176,
      "name": "FormField",
      "parent": 174,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-176"
        },
        "width": {
          "type": "value",
          "value": "10"
        }
      },
      "seq": 176,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 177,
      "name": "FormGroup",
      "parent": 176,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormGroup-8"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px\",  }"
        },
        "widths": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 177,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 182,
      "name": "FormField",
      "parent": 177,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-11"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"20px 0px 20px 30px\", borderTop: \"1px dashed var(--primary-theme-color)\", borderLeft: \"1px dashed var(--primary-theme-color)\" }"
        },
        "width": {
          "type": "value",
          "value": "4"
        }
      },
      "seq": 182,
      "void": false
    },
    {
      "from": null,
      "id": 183,
      "name": "div",
      "parent": 182,
      "props": {
        "children": {
          "type": "value",
          "value": "เงินสด"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-140"
        }
      },
      "seq": 183,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 184,
      "name": "FormField",
      "parent": 177,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-12"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"20px 0px 20px 0px\", borderTop: \"1px dashed var(--primary-theme-color)\", }"
        },
        "width": {
          "type": "value",
          "value": "4"
        }
      },
      "seq": 184,
      "void": false
    },
    {
      "from": null,
      "id": 185,
      "name": "div",
      "parent": 184,
      "props": {
        "children": {
          "type": "code",
          "value": "props.inputCashAmountText"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-20"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 185,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 186,
      "name": "FormField",
      "parent": 177,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-13"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"20px 10px 20px 10px\", borderTop: \"1px dashed var(--primary-theme-color)\", }"
        },
        "width": {
          "type": "value",
          "value": "1"
        }
      },
      "seq": 186,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 187,
      "name": "FormField",
      "parent": 177,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-14"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"20px 0px 20px 30px\", borderTop: \"1px dashed var(--primary-theme-color)\", }"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 187,
      "void": false
    },
    {
      "from": null,
      "id": 188,
      "name": "div",
      "parent": 187,
      "props": {
        "children": {
          "type": "value",
          "value": "เงินทอน"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-148"
        }
      },
      "seq": 188,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 189,
      "name": "FormField",
      "parent": 177,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-15"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"20px 30px 20px 0px\", borderTop: \"1px dashed var(--primary-theme-color)\", borderRight: \"1px dashed var(--primary-theme-color)\", }"
        },
        "width": {
          "type": "value",
          "value": "4"
        }
      },
      "seq": 189,
      "void": false
    },
    {
      "from": null,
      "id": 190,
      "name": "div",
      "parent": 189,
      "props": {
        "children": {
          "type": "code",
          "value": "( props.changeText  || \"0.00\" )"
        },
        "className": {
          "type": "value",
          "value": "ui label large fluid"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-21"
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"right\" }"
        }
      },
      "seq": 190,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 191,
      "name": "FormGroup",
      "parent": 175,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormGroup-8"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px\",  }"
        },
        "widths": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 191,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 192,
      "name": "FormField",
      "parent": 191,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-9"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"20px 0px 20px\", }"
        },
        "width": {
          "type": "value",
          "value": "7"
        }
      },
      "seq": 192,
      "void": false
    },
    {
      "from": null,
      "id": 193,
      "name": "div",
      "parent": 192,
      "props": {
        "children": {
          "type": "value",
          "value": "ค่าใช้จ่ายทั้งหมด"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-147"
        }
      },
      "seq": 193,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 194,
      "name": "FormField",
      "parent": 191,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-10"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"20px 20px 20px 10px\", }"
        },
        "width": {
          "type": "value",
          "value": "9"
        }
      },
      "seq": 194,
      "void": false
    },
    {
      "from": null,
      "id": 195,
      "name": "div",
      "parent": 194,
      "props": {
        "children": {
          "type": "code",
          "value": "( props.sumAmount.price || \"0.00\" )"
        },
        "className": {
          "type": "value",
          "value": "ui label large fluid"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-19"
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"right\" }"
        }
      },
      "seq": 195,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 196,
      "name": "FormGroup",
      "parent": 175,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormGroup-26"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px\",  }"
        }
      },
      "seq": 196,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 197,
      "name": "FormField",
      "parent": 196,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-67"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 0px 20px 0px\", }"
        },
        "width": {
          "type": "value",
          "value": "7"
        }
      },
      "seq": 197,
      "void": false
    },
    {
      "from": null,
      "id": 198,
      "name": "div",
      "parent": 197,
      "props": {
        "children": {
          "type": "value",
          "value": "ส่วนลดรวม (ท้ายใบเสร็จ)"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-149"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"var(--primary-theme-color)\"  }"
        }
      },
      "seq": 198,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 199,
      "name": "FormField",
      "parent": 196,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-68"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 20px 20px 10px\", }"
        },
        "width": {
          "type": "value",
          "value": "9"
        }
      },
      "seq": 199,
      "void": false
    },
    {
      "from": null,
      "id": 200,
      "name": "div",
      "parent": 199,
      "props": {
        "children": {
          "type": "code",
          "value": "props.inputDiscountCode"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-109"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 200,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 211,
      "name": "FormGroup",
      "parent": 176,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormGroup-26"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px\",  }"
        }
      },
      "seq": 211,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 216,
      "name": "FormField",
      "parent": 211,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-69"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 0px 20px 30px\", borderLeft: \"1px dashed var(--primary-theme-color)\" }"
        },
        "width": {
          "type": "value",
          "value": "4"
        }
      },
      "seq": 216,
      "void": false
    },
    {
      "from": null,
      "id": 217,
      "name": "div",
      "parent": 216,
      "props": {
        "children": {
          "type": "value",
          "value": "เงินโอน/QR Code"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-141"
        }
      },
      "seq": 217,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 218,
      "name": "FormField",
      "parent": 211,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-70"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 0px 20px 0px\", }"
        },
        "width": {
          "type": "value",
          "value": "4"
        }
      },
      "seq": 218,
      "void": false
    },
    {
      "from": null,
      "id": 219,
      "name": "div",
      "parent": 218,
      "props": {
        "children": {
          "type": "code",
          "value": "( props.transferText || \"0.00\" )"
        },
        "className": {
          "type": "value",
          "value": "ui label large fluid"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-108"
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"right\" }"
        }
      },
      "seq": 219,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 220,
      "name": "FormField",
      "parent": 211,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-71"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 10px 20px 10px\",  }"
        },
        "width": {
          "type": "value",
          "value": "1"
        }
      },
      "seq": 220,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 221,
      "name": "Button",
      "parent": 220,
      "props": {
        "circular": {
          "type": "code",
          "value": "true"
        },
        "icon": {
          "type": "value",
          "value": "plus"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-Button-133"
        },
        "onClick": {
          "type": "code",
          "value": "()=> props.onAddPaymentMethod(2)"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{ background: \"var(--primary-theme-color)\", color: \"white\" }"
        },
        "type": {
          "type": "value",
          "value": "button"
        }
      },
      "seq": 221,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 222,
      "name": "FormField",
      "parent": 211,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-72"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 0px 20px 30px\", }"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 222,
      "void": false
    },
    {
      "from": null,
      "id": 223,
      "name": "div",
      "parent": 222,
      "props": {
        "children": {
          "type": "value",
          "value": "ลดเศษสตางค์"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-150"
        }
      },
      "seq": 223,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 224,
      "name": "FormField",
      "parent": 211,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-73"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 30px 20px 0px\", borderRight: \"1px dashed var(--primary-theme-color)\", }"
        },
        "width": {
          "type": "value",
          "value": "4"
        }
      },
      "seq": 224,
      "void": false
    },
    {
      "from": null,
      "id": 225,
      "name": "div",
      "parent": 224,
      "props": {
        "children": {
          "type": "code",
          "value": "( props.roundOffText || \"\\u00a0\" )"
        },
        "className": {
          "type": "value",
          "value": "ui label large fluid"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-107"
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"right\" }"
        }
      },
      "seq": 225,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 226,
      "name": "FormGroup",
      "parent": 176,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormGroup-27"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px\",  }"
        }
      },
      "seq": 226,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 231,
      "name": "FormField",
      "parent": 226,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-62"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 0px 20px 30px\", borderLeft: \"1px dashed var(--primary-theme-color)\" }"
        },
        "width": {
          "type": "value",
          "value": "4"
        }
      },
      "seq": 231,
      "void": false
    },
    {
      "from": null,
      "id": 232,
      "name": "div",
      "parent": 231,
      "props": {
        "children": {
          "type": "value",
          "value": "บัตรเครดิต"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-142"
        }
      },
      "seq": 232,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 233,
      "name": "FormField",
      "parent": 226,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-63"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 0px 20px 0px\", }"
        },
        "width": {
          "type": "value",
          "value": "4"
        }
      },
      "seq": 233,
      "void": false
    },
    {
      "from": null,
      "id": 234,
      "name": "div",
      "parent": 233,
      "props": {
        "children": {
          "type": "code",
          "value": "( props.cardText || \"0.00\" )"
        },
        "className": {
          "type": "value",
          "value": "ui label large fluid"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-105"
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"right\" }"
        }
      },
      "seq": 234,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 235,
      "name": "FormField",
      "parent": 226,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-64"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 10px 20px 10px\",  }"
        },
        "width": {
          "type": "value",
          "value": "1"
        }
      },
      "seq": 235,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 236,
      "name": "Button",
      "parent": 235,
      "props": {
        "circular": {
          "type": "code",
          "value": "true"
        },
        "icon": {
          "type": "value",
          "value": "plus"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-Button-132"
        },
        "onClick": {
          "type": "code",
          "value": "()=> props.onAddPaymentMethod(3)"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{ background: \"var(--primary-theme-color)\", color: \"white\" }"
        },
        "type": {
          "type": "value",
          "value": "button"
        }
      },
      "seq": 236,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 237,
      "name": "FormField",
      "parent": 226,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-65"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 0px 20px 30px\", }"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 237,
      "void": false
    },
    {
      "from": null,
      "id": 238,
      "name": "label",
      "parent": 237,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-label-79"
        }
      },
      "seq": 238,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 239,
      "name": "FormField",
      "parent": 226,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-66"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 30px 20px 0px\", borderRight: \"1px dashed var(--primary-theme-color)\", }"
        },
        "width": {
          "type": "value",
          "value": "4"
        }
      },
      "seq": 239,
      "void": false
    },
    {
      "from": null,
      "id": 240,
      "name": "div",
      "parent": 239,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-104"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 240,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 241,
      "name": "FormGroup",
      "parent": 175,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormGroup-27"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px\",  }"
        }
      },
      "seq": 315,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 242,
      "name": "FormField",
      "parent": 241,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-60"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 0px 20px 0px\", }"
        },
        "width": {
          "type": "value",
          "value": "7"
        }
      },
      "seq": 242,
      "void": false
    },
    {
      "from": null,
      "id": 243,
      "name": "div",
      "parent": 242,
      "props": {
        "children": {
          "type": "value",
          "value": "ต้องชำระ"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-151"
        }
      },
      "seq": 243,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 244,
      "name": "FormField",
      "parent": 241,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-61"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 20px 20px 10px\", }"
        },
        "width": {
          "type": "value",
          "value": "9"
        }
      },
      "seq": 244,
      "void": false
    },
    {
      "from": null,
      "id": 245,
      "name": "div",
      "parent": 244,
      "props": {
        "children": {
          "type": "code",
          "value": "(props.sumAmount.payable || \"0.00\")"
        },
        "className": {
          "type": "value",
          "value": "ui label large fluid"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-106"
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"right\", background: \"rgba(255, 230, 230, 1)\" }"
        }
      },
      "seq": 245,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 246,
      "name": "FormGroup",
      "parent": 175,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormGroup-28"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px\",  }"
        }
      },
      "seq": 319,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 247,
      "name": "FormField",
      "parent": 246,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-53"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 0px 20px 0px\", }"
        },
        "width": {
          "type": "value",
          "value": "7"
        }
      },
      "seq": 247,
      "void": false
    },
    {
      "from": null,
      "id": 248,
      "name": "div",
      "parent": 247,
      "props": {
        "children": {
          "type": "value",
          "value": "ยอดคงเหลือต้องชำระ"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-152"
        }
      },
      "seq": 248,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 249,
      "name": "FormField",
      "parent": 246,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-54"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 20px 20px 10px\", }"
        },
        "width": {
          "type": "value",
          "value": "9"
        }
      },
      "seq": 249,
      "void": false
    },
    {
      "from": null,
      "id": 250,
      "name": "div",
      "parent": 249,
      "props": {
        "children": {
          "type": "code",
          "value": "props.oweText"
        },
        "className": {
          "type": "code",
          "value": "`ui label large fluid ${Number(props.rawOweText) > Number(props.rawTotalText) ? \"red\" : \"green\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-103"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", display: \"flex\", justifyContent: \"flex-end\" }"
        }
      },
      "seq": 250,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 261,
      "name": "FormGroup",
      "parent": 176,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormGroup-28"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px\",  }"
        }
      },
      "seq": 261,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 266,
      "name": "FormField",
      "parent": 261,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-55"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 0px 20px 30px\", borderLeft: \"1px dashed var(--primary-theme-color)\" }"
        },
        "width": {
          "type": "value",
          "value": "4"
        }
      },
      "seq": 266,
      "void": false
    },
    {
      "from": null,
      "id": 267,
      "name": "div",
      "parent": 266,
      "props": {
        "children": {
          "type": "value",
          "value": "บัตรเดบิต"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-143"
        }
      },
      "seq": 267,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 268,
      "name": "FormField",
      "parent": 261,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-56"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 0px 20px 0px\", }"
        },
        "width": {
          "type": "value",
          "value": "4"
        }
      },
      "seq": 268,
      "void": false
    },
    {
      "from": null,
      "id": 269,
      "name": "div",
      "parent": 268,
      "props": {
        "children": {
          "type": "code",
          "value": "( props.cardDebitText || \"0.00\" )"
        },
        "className": {
          "type": "value",
          "value": "ui label large fluid"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-102"
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"right\" }"
        }
      },
      "seq": 269,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 270,
      "name": "FormField",
      "parent": 261,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-57"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 10px 20px 10px\",  }"
        },
        "width": {
          "type": "value",
          "value": "1"
        }
      },
      "seq": 270,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 271,
      "name": "Button",
      "parent": 270,
      "props": {
        "circular": {
          "type": "code",
          "value": "true"
        },
        "icon": {
          "type": "value",
          "value": "plus"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-Button-131"
        },
        "onClick": {
          "type": "code",
          "value": "()=> props.onAddPaymentMethod(9)"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{ background: \"var(--primary-theme-color)\", color: \"white\" }"
        },
        "type": {
          "type": "value",
          "value": "button"
        }
      },
      "seq": 271,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 272,
      "name": "FormField",
      "parent": 261,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-58"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 0px 20px 30px\", }"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 272,
      "void": false
    },
    {
      "from": null,
      "id": 273,
      "name": "label",
      "parent": 272,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-label-82"
        }
      },
      "seq": 273,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 274,
      "name": "FormField",
      "parent": 261,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-59"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 30px 20px 0px\", borderRight: \"1px dashed var(--primary-theme-color)\", }"
        },
        "width": {
          "type": "value",
          "value": "4"
        }
      },
      "seq": 274,
      "void": false
    },
    {
      "from": null,
      "id": 275,
      "name": "div",
      "parent": 274,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-101"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 275,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 276,
      "name": "FormGroup",
      "parent": 176,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormGroup-29"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px\",  }"
        }
      },
      "seq": 276,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 279,
      "name": "FormField",
      "parent": 276,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-48"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 0px 20px 30px\", borderLeft: \"1px dashed var(--primary-theme-color)\" }"
        },
        "width": {
          "type": "value",
          "value": "4"
        }
      },
      "seq": 279,
      "void": false
    },
    {
      "from": null,
      "id": 280,
      "name": "div",
      "parent": 279,
      "props": {
        "children": {
          "type": "value",
          "value": "แคชเชียร์เช็ค"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-144"
        }
      },
      "seq": 280,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 281,
      "name": "FormField",
      "parent": 276,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-49"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 0px 20px 0px\", }"
        },
        "width": {
          "type": "value",
          "value": "4"
        }
      },
      "seq": 281,
      "void": false
    },
    {
      "from": null,
      "id": 282,
      "name": "div",
      "parent": 281,
      "props": {
        "children": {
          "type": "code",
          "value": "( props.chequeText || \"0.00\")"
        },
        "className": {
          "type": "value",
          "value": "ui label large fluid"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-99"
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"right\" }"
        }
      },
      "seq": 282,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 283,
      "name": "FormField",
      "parent": 276,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-50"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 10px 20px 10px\",  }"
        },
        "width": {
          "type": "value",
          "value": "1"
        }
      },
      "seq": 283,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 284,
      "name": "Button",
      "parent": 283,
      "props": {
        "circular": {
          "type": "code",
          "value": "true"
        },
        "icon": {
          "type": "value",
          "value": "plus"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-Button-130"
        },
        "onClick": {
          "type": "code",
          "value": "()=> props.onAddPaymentMethod(4)"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{ background: \"var(--primary-theme-color)\", color: \"white\" }"
        },
        "type": {
          "type": "value",
          "value": "button"
        }
      },
      "seq": 284,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 285,
      "name": "FormField",
      "parent": 276,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-51"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 0px 20px 30px\", }"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 285,
      "void": false
    },
    {
      "from": null,
      "id": 286,
      "name": "label",
      "parent": 285,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-label-85"
        }
      },
      "seq": 286,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 287,
      "name": "FormField",
      "parent": 276,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-52"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 30px 20px 0px\", borderRight: \"1px dashed var(--primary-theme-color)\", }"
        },
        "width": {
          "type": "value",
          "value": "4"
        }
      },
      "seq": 287,
      "void": false
    },
    {
      "from": null,
      "id": 288,
      "name": "div",
      "parent": 287,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-98"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 288,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 290,
      "name": "FormGroup",
      "parent": 176,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormGroup-30"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px\",  }"
        }
      },
      "seq": 290,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 293,
      "name": "FormField",
      "parent": 290,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-41"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 0px 20px 30px\", borderLeft: \"1px dashed var(--primary-theme-color)\" }"
        },
        "width": {
          "type": "value",
          "value": "4"
        }
      },
      "seq": 293,
      "void": false
    },
    {
      "from": null,
      "id": 294,
      "name": "div",
      "parent": 293,
      "props": {
        "children": {
          "type": "value",
          "value": "คูปองเงินสด"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-145"
        }
      },
      "seq": 294,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 295,
      "name": "FormField",
      "parent": 290,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-42"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 0px 20px 0px\", }"
        },
        "width": {
          "type": "value",
          "value": "4"
        }
      },
      "seq": 295,
      "void": false
    },
    {
      "from": null,
      "id": 296,
      "name": "div",
      "parent": 295,
      "props": {
        "children": {
          "type": "code",
          "value": "( props.couponText || \"0.00\" )"
        },
        "className": {
          "type": "value",
          "value": "ui label large fluid"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-97"
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"right\" }"
        }
      },
      "seq": 296,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 297,
      "name": "FormField",
      "parent": 290,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-43"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 10px 20px 10px\",  }"
        },
        "width": {
          "type": "value",
          "value": "1"
        }
      },
      "seq": 297,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 298,
      "name": "Button",
      "parent": 297,
      "props": {
        "circular": {
          "type": "code",
          "value": "true"
        },
        "icon": {
          "type": "value",
          "value": "plus"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-Button-129"
        },
        "onClick": {
          "type": "code",
          "value": "()=> props.onAddPaymentMethod(5)"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{ background: \"var(--primary-theme-color)\", color: \"white\" }"
        },
        "type": {
          "type": "value",
          "value": "button"
        }
      },
      "seq": 298,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 299,
      "name": "FormField",
      "parent": 290,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-44"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 0px 20px 30px\", }"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 299,
      "void": false
    },
    {
      "from": null,
      "id": 300,
      "name": "label",
      "parent": 299,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-label-88"
        }
      },
      "seq": 300,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 301,
      "name": "FormField",
      "parent": 290,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-45"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 30px 20px 0px\", borderRight: \"1px dashed var(--primary-theme-color)\", }"
        },
        "width": {
          "type": "value",
          "value": "4"
        }
      },
      "seq": 301,
      "void": false
    },
    {
      "from": null,
      "id": 302,
      "name": "div",
      "parent": 301,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-94"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 302,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 303,
      "name": "FormGroup",
      "parent": 176,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormGroup-31"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px\",  }"
        }
      },
      "seq": 303,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 306,
      "name": "FormField",
      "parent": 303,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-34"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 0px 20px 30px\", borderBottom: \"1px dashed var(--primary-theme-color)\", borderLeft: \"1px dashed var(--primary-theme-color)\" }"
        },
        "width": {
          "type": "value",
          "value": "4"
        }
      },
      "seq": 306,
      "void": false
    },
    {
      "from": null,
      "id": 307,
      "name": "label",
      "parent": 306,
      "props": {
        "children": {
          "type": "value",
          "value": "รวมยอดชำระทั้งหมด"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-label-90"
        }
      },
      "seq": 307,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 308,
      "name": "FormField",
      "parent": 303,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-35"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 0px 20px 0px\", borderBottom: \"1px dashed var(--primary-theme-color)\",  }"
        },
        "width": {
          "type": "value",
          "value": "4"
        }
      },
      "seq": 308,
      "void": false
    },
    {
      "from": null,
      "id": 309,
      "name": "div",
      "parent": 308,
      "props": {
        "children": {
          "type": "code",
          "value": "( props.totalText || \"0.00\" )"
        },
        "className": {
          "type": "value",
          "value": "ui label large fluid"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-96"
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"right\", background: \"rgba(255, 230, 230, 1)\" }"
        }
      },
      "seq": 309,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 310,
      "name": "FormField",
      "parent": 303,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-36"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 10px 20px 10px\", borderBottom: \"1px dashed var(--primary-theme-color)\",  }"
        },
        "width": {
          "type": "value",
          "value": "1"
        }
      },
      "seq": 310,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 311,
      "name": "FormField",
      "parent": 303,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-37"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 0px 20px 30px\",  borderBottom: \"1px dashed var(--primary-theme-color)\", }"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 311,
      "void": false
    },
    {
      "from": null,
      "id": 312,
      "name": "label",
      "parent": 311,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-label-91"
        }
      },
      "seq": 312,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 313,
      "name": "FormField",
      "parent": 303,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-38"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 30px 20px 0px\", borderBottom: \"1px dashed var(--primary-theme-color)\", borderRight: \"1px dashed var(--primary-theme-color)\" }"
        },
        "width": {
          "type": "value",
          "value": "4"
        }
      },
      "seq": 313,
      "void": false
    },
    {
      "from": null,
      "id": 314,
      "name": "div",
      "parent": 313,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-92"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 314,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 315,
      "name": "FormGroup",
      "parent": 175,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormGroup-28"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px\",  }"
        }
      },
      "seq": 325,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 316,
      "name": "FormField",
      "parent": 315,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-53"
        },
        "style": {
          "type": "code",
          "value": "{ padding : \"0px 0px 20px 0px\", }"
        },
        "width": {
          "type": "value",
          "value": "16"
        }
      },
      "seq": 316,
      "void": false
    },
    {
      "from": null,
      "id": 317,
      "name": "div",
      "parent": 316,
      "props": {
        "children": {
          "type": "value",
          "value": "หมายเหตุ"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-152"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"10px 0px\" }"
        }
      },
      "seq": 317,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 318,
      "name": "TextArea",
      "parent": 316,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-TextArea-318"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeRemark"
        },
        "rows": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ resize: \"none\" }"
        },
        "value": {
          "type": "code",
          "value": "props.remarkText"
        }
      },
      "seq": 318,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 319,
      "name": "FormGroup",
      "parent": 175,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormGroup-27"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px\",  }"
        }
      },
      "seq": 241,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 320,
      "name": "FormField",
      "parent": 319,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-60"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 0px 5px 0px\", }"
        },
        "width": {
          "type": "value",
          "value": "7"
        }
      },
      "seq": 320,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 322,
      "name": "FormField",
      "parent": 319,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-61"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 20px 5px 10px\", }"
        },
        "width": {
          "type": "value",
          "value": "9"
        }
      },
      "seq": 322,
      "void": false
    },
    {
      "from": null,
      "id": 323,
      "name": "div",
      "parent": 322,
      "props": {
        "children": {
          "type": "code",
          "value": "props.voucherInput"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-323"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 323,
      "void": false
    },
    {
      "from": null,
      "id": 324,
      "name": "div",
      "parent": 320,
      "props": {
        "children": {
          "type": "value",
          "value": "คูปองส่วนลด (Voucher)"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-324"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"var(--primary-theme-color)\"  }"
        }
      },
      "seq": 324,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 325,
      "name": "FormGroup",
      "parent": 175,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormGroup-27"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px\",  }"
        }
      },
      "seq": 246,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 326,
      "name": "FormField",
      "parent": 325,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-60"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 0px 20px 0px\", }"
        },
        "width": {
          "type": "value",
          "value": "7"
        }
      },
      "seq": 326,
      "void": false
    },
    {
      "from": null,
      "id": 327,
      "name": "div",
      "parent": 326,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectVoucherHeader"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-324"
        }
      },
      "seq": 327,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 328,
      "name": "FormField",
      "parent": 325,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-61"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", padding : \"0px 20px 20px 10px\", }"
        },
        "width": {
          "type": "value",
          "value": "9"
        }
      },
      "seq": 328,
      "void": false
    },
    {
      "from": null,
      "id": 329,
      "name": "div",
      "parent": 328,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectVoucherData"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-323"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 329,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 330,
      "name": "FormGroup",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormGroup-330"
        }
      },
      "seq": 330,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 331,
      "name": "FormField",
      "parent": 330,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-155"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 331,
      "void": false
    },
    {
      "from": null,
      "id": 332,
      "name": "div",
      "parent": 331,
      "props": {
        "children": {
          "type": "value",
          "value": "Affiliate code"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-div-161"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", marginTop: \"0px\" }"
        }
      },
      "seq": 332,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 333,
      "name": "FormField",
      "parent": 330,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-155"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 333,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 335,
      "name": "FormField",
      "parent": 330,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-155"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 335,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 337,
      "name": "Input",
      "parent": 333,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-Input-337"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeAffiliateCode"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e) => { if (e.key === \"Enter\") props.onCheckAffiliate?.(); }"
        },
        "style": {
          "type": "code",
          "value": "{ border: (props.affiliate?.code && !props.affiliate?.name) ? \"1px solid red\" : undefined }"
        },
        "value": {
          "type": "code",
          "value": "props.affiliate?.code || \"\""
        }
      },
      "seq": 337,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 339,
      "name": "FormField",
      "parent": 330,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-FormField-155"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 339,
      "void": false
    },
    {
      "from": null,
      "id": 340,
      "name": "label",
      "parent": 339,
      "props": {
        "children": {
          "type": "code",
          "value": "props.affiliate?.name || \"\""
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-label-340"
        }
      },
      "seq": 340,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 341,
      "name": "Button",
      "parent": 335,
      "props": {
        "children": {
          "type": "value",
          "value": "check"
        },
        "color": {
          "type": "value",
          "value": "teal"
        },
        "disabled": {
          "type": "code",
          "value": "!props.affiliate?.code?.trim() || props.affiliate?.checking"
        },
        "id": {
          "type": "value",
          "value": "CardPayingMeBillingUX-Button-165"
        },
        "loading": {
          "type": "code",
          "value": "props.affiliate?.checking"
        },
        "onClick": {
          "type": "code",
          "value": "props.onCheckAffiliate"
        },
        "size": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "value",
          "value": ""
        },
        "type": {
          "type": "value",
          "value": "button"
        }
      },
      "seq": 341,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "CardPayingMeBillingUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
